import React from './react';

type IconProps = { size?: number; className?: string; strokeWidth?: number };
const paths: Record<string, string[]> = {
  Plus: ['M12 5v14', 'M5 12h14'],
  Minus: ['M5 12h14'],
  X: ['M6 6l12 12', 'M18 6L6 18'],
  Menu: ['M4 6h16', 'M4 12h16', 'M4 18h16'],
  Search: ['M21 21l-4.3-4.3', 'M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16'],
  ChevronDown: ['M6 9l6 6 6-6'],
  ArrowRight: ['M5 12h14', 'M13 6l6 6-6 6'],
  ArrowLeft: ['M19 12H5', 'M11 6l-6 6 6 6'],
  ArrowUpRight: ['M7 17L17 7', 'M7 7h10v10'],
  ArrowDownRight: ['M7 7l10 10', 'M7 17h10V7'],
  ArrowRightLeft: ['M7 7h14', 'M17 3l4 4-4 4', 'M17 17H3', 'M7 13l-4 4 4 4'],
  More: ['M5 12h.01', 'M12 12h.01', 'M19 12h.01'],
  Clock3: ['M12 7v5l3 2', 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18'],
  CircleCheck: ['M7 12l3 3 7-7', 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18'],
  AlertTriangle: ['M12 3l10 18H2L12 3z', 'M12 9v4', 'M12 17h.01'],
  ShoppingCart: ['M3 4h2l2 11h10l2-8H6', 'M9 20h.01', 'M17 20h.01'],
  ShoppingBag: ['M6 8h12l1 13H5L6 8z', 'M9 8a3 3 0 0 1 6 0'],
  Store: ['M3 9l2-5h14l2 5', 'M5 9v11h14V9', 'M9 20v-6h6v6'],
  Building2: ['M4 21V3h12v18', 'M16 9h4v12', 'M8 7h4', 'M8 11h4', 'M8 15h4'],
  UserRound: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8', 'M4 21a8 8 0 0 1 16 0'],
  UserPlus: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8', 'M4 21a8 8 0 0 1 12-7', 'M19 14v6', 'M16 17h6'],
  Mail: ['M3 5h18v14H3z', 'M3 6l9 7 9-7'],
  AtSign: ['M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8', 'M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0'],
  LockKeyhole: ['M6 10h12v11H6z', 'M8 10V7a4 4 0 0 1 8 0v3', 'M12 14v3'],
  KeyRound: ['M15 7a5 5 0 1 1-3.5 8.5L3 24', 'M8 19l2 2', 'M11 16l2 2'],
  ShieldCheck: ['M12 2l8 4v6c0 5-3.4 8.5-8 10-4.6-1.5-8-5-8-10V6l8-4z', 'M8 12l3 3 5-6'],
  LogOut: ['M10 17l5-5-5-5', 'M15 12H3', 'M14 3h6v18h-6'],
  Image: ['M3 4h18v16H3z', 'M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4', 'M3 17l5-5 4 4 3-3 6 6'],
  ContactRound: ['M8 7a3 3 0 1 0 0-6', 'M3 15a5 5 0 0 1 10 0', 'M16 8h5', 'M16 12h5', 'M16 16h5'],
  Bell: ['M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9', 'M10 21h4'],
  Moon: ['M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8z'],
  Sun: ['M12 4V2', 'M12 22v-2', 'M4 12H2', 'M22 12h-2', 'M6.3 6.3 4.9 4.9', 'M19.1 19.1l-1.4-1.4', 'M17.7 6.3l1.4-1.4', 'M4.9 19.1l1.4-1.4', 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10'],
  Wifi: ['M5 12.5a10 10 0 0 1 14 0', 'M8.5 16a5 5 0 0 1 7 0', 'M12 20h.01'],
  MapPin: ['M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0', 'M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4'],
  ExternalLink: ['M14 3h7v7', 'M10 14L21 3', 'M21 14v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6'],
  CalendarDays: ['M6 2v4', 'M18 2v4', 'M3 9h18', 'M5 4h14a2 2 0 0 1 2 2v15H3V6a2 2 0 0 1 2-2'],
  LayoutDashboard: ['M3 3h7v8H3z', 'M14 3h7v5h-7z', 'M14 12h7v9h-7z', 'M3 15h7v6H3z'],
  Grid2X2: ['M3 3h8v8H3z', 'M13 3h8v8h-8z', 'M3 13h8v8H3z', 'M13 13h8v8h-8z'],
  List: ['M8 6h13', 'M8 12h13', 'M8 18h13', 'M3 6h.01', 'M3 12h.01', 'M3 18h.01'],
  Boxes: ['M4 7l8-4 8 4-8 4-8-4z', 'M4 7v10l8 4 8-4V7', 'M12 11v10'],
  PackageSearch: ['M4 7l8-4 8 4-8 4-8-4z', 'M4 7v10l8 4 4-2', 'M12 11v6', 'M17 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6', 'M19 19l2 2'],
  ClipboardList: ['M9 4h6', 'M9 2h6v4H9z', 'M6 4H4v17h16V4h-2', 'M8 11h8', 'M8 15h8'],
  Truck: ['M3 6h11v10H3z', 'M14 10h4l3 3v3h-7z', 'M7 20a2 2 0 1 0 0-4', 'M18 20a2 2 0 1 0 0-4'],
  CircleDollarSign: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18', 'M16 8h-6a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8', 'M12 6v12'],
  Banknote: ['M3 6h18v12H3z', 'M7 9a3 3 0 0 1-3 3 3 3 0 0 1 3 3', 'M17 9a3 3 0 0 0 3 3 3 3 0 0 0-3 3', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6'],
  CreditCard: ['M3 5h18v14H3z', 'M3 10h18', 'M7 15h3'],
  WalletCards: ['M4 7h15a2 2 0 0 1 2 2v10H4a2 2 0 0 1-2-2V7z', 'M4 7l13-3v3', 'M16 13h5'],
  BarChart3: ['M3 3v18h18', 'M7 16v-4', 'M12 16V8', 'M17 16V5'],
  Settings: ['M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7', 'M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2 3.4-.2-.1a1.7 1.7 0 0 0-1.9-.3l-.7.4a1.7 1.7 0 0 0-.9 1.5V22h-4v-.1a1.7 1.7 0 0 0-.9-1.5l-.7-.4a1.7 1.7 0 0 0-1.9.3l-.2.1-2-3.4.1-.1A1.7 1.7 0 0 0 4.6 15l-.4-.7A1.7 1.7 0 0 0 2.7 13H2V9h.7a1.7 1.7 0 0 0 1.5-1l.4-.7a1.7 1.7 0 0 0-.3-1.9l-.1-.1 2-3.4.2.1a1.7 1.7 0 0 0 1.9.3l.7-.4A1.7 1.7 0 0 0 9.9.4V0h4v.4a1.7 1.7 0 0 0 .9 1.5l.7.4a1.7 1.7 0 0 0 1.9-.3l.2-.1 2 3.4-.1.1a1.7 1.7 0 0 0-.3 1.9l.4.7a1.7 1.7 0 0 0 1.5 1h.7v4h-.7a1.7 1.7 0 0 0-1.5 1z'],
  SlidersHorizontal: ['M4 6h16', 'M4 12h16', 'M4 18h16', 'M8 4v4', 'M16 10v4', 'M10 16v4'],
  Trash2: ['M3 6h18', 'M8 6V3h8v3', 'M6 6l1 15h10l1-15', 'M10 10v7', 'M14 10v7'],
  Construction: ['M3 21l9-9', 'M14 4l6 6', 'M13 5l2-2 6 6-2 2', 'M5 13l6 6'],
  Database: ['M4 6c0-2 16-2 16 0s-16 2-16 0', 'M4 6v12c0 2 16 2 16 0V6', 'M4 12c0 2 16 2 16 0'],
  Layers3: ['M12 2l9 5-9 5-9-5 9-5z', 'M3 12l9 5 9-5', 'M3 17l9 5 9-5'],
  Pencil: ['M4 20h4l11-11-4-4L4 16v4z', 'M13 7l4 4'],
  Copy: ['M8 8h12v12H8z', 'M4 16H3V4h12v1'],
  Archive: ['M3 6h18v4H3z', 'M5 10v10h14V10', 'M10 14h4'],
  RotateCcw: ['M3 12a9 9 0 1 0 3-6.7', 'M3 3v6h6'],
  Download: ['M12 3v12', 'M7 10l5 5 5-5', 'M5 21h14'],
  Upload: ['M12 21V9', 'M7 14l5-5 5 5', 'M5 3h14'],
  Tags: ['M3 12V4h8l10 10-8 8L3 12z', 'M7 8h.01'],
  History: ['M3 12a9 9 0 1 0 3-6.7', 'M3 3v6h6', 'M12 7v5l3 2'],
  ArrowUpDown: ['M7 3v18', 'M3 7l4-4 4 4', 'M17 21V3', 'M13 17l4 4 4-4'],
  Sparkles: ['M12 3l1.3 3.7L17 8l-3.7 1.3L12 13l-1.3-3.7L7 8l3.7-1.3L12 3z', 'M19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8L19 14z'],
  Mic: ['M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z','M19 10v2a7 7 0 0 1-14 0v-2','M12 19v3','M8 22h8'],
  QrCode: ['M3 3h7v7H3z','M14 3h7v7h-7z','M3 14h7v7H3z','M14 14h3v3h-3z','M18 14h3v7h-3z','M14 18h3v3h-3z'],
  Share2: ['M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6', 'M6 15a3 3 0 1 0 0 6 3 3 0 0 0 0-6', 'M18 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6', 'M8.6 13.5l6.8-4', 'M8.6 16.5l6.8 4'],
};

function makeIcon(name: string) {
  return function Icon({ size = 24, className, strokeWidth = 2 }: IconProps) {
    const iconPaths = paths[name] ?? ['M4 4h16v16H4z'];
    return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">{iconPaths.map((d, index) => d.includes('a') && !d.startsWith('M') ? <path key={index} d={d} /> : <path key={index} d={d} />)}</svg>;
  };
}

export const AlertTriangle = makeIcon('AlertTriangle');
export const AtSign = makeIcon('AtSign');
export const Image = makeIcon('Image');
export const KeyRound = makeIcon('KeyRound');
export const LockKeyhole = makeIcon('LockKeyhole');
export const LogOut = makeIcon('LogOut');
export const Mail = makeIcon('Mail');
export const ShieldCheck = makeIcon('ShieldCheck');
export const UserPlus = makeIcon('UserPlus');
export const ArrowDownRight = makeIcon('ArrowDownRight');
export const ArrowRightLeft = makeIcon('ArrowRightLeft');
export const ArrowLeft = makeIcon('ArrowLeft');
export const ArrowRight = makeIcon('ArrowRight');
export const ArrowUpRight = makeIcon('ArrowUpRight');
export const BarChart3 = makeIcon('BarChart3');
export const Bell = makeIcon('Bell');
export const Boxes = makeIcon('Boxes');
export const Building2 = makeIcon('Building2');
export const CalendarDays = makeIcon('CalendarDays');
export const ChevronDown = makeIcon('ChevronDown');
export const CircleCheck = makeIcon('CircleCheck');
export const CircleDollarSign = makeIcon('CircleDollarSign');
export const Banknote = makeIcon('Banknote');
export const CreditCard = makeIcon('CreditCard');
export const WalletCards = makeIcon('WalletCards');
export const ClipboardList = makeIcon('ClipboardList');
export const Clock3 = makeIcon('Clock3');
export const Construction = makeIcon('Construction');
export const ContactRound = makeIcon('ContactRound');
export const Database = makeIcon('Database');
export const ExternalLink = makeIcon('ExternalLink');
export const Grid2X2 = makeIcon('Grid2X2');
export const Layers3 = makeIcon('Layers3');
export const Pencil = makeIcon('Pencil');
export const Copy = makeIcon('Copy');
export const Archive = makeIcon('Archive');
export const RotateCcw = makeIcon('RotateCcw');
export const Download = makeIcon('Download');
export const Upload = makeIcon('Upload');
export const Tags = makeIcon('Tags');
export const History = makeIcon('History');
export const ArrowUpDown = makeIcon('ArrowUpDown');
export const Sparkles = makeIcon('Sparkles');
export const LayoutDashboard = makeIcon('LayoutDashboard');
export const List = makeIcon('List');
export const MapPin = makeIcon('MapPin');
export const Menu = makeIcon('Menu');
export const Minus = makeIcon('Minus');
export const Moon = makeIcon('Moon');
export const PackageSearch = makeIcon('PackageSearch');
export const Plus = makeIcon('Plus');
export const Search = makeIcon('Search');
export const Settings = makeIcon('Settings');
export const ShoppingBag = makeIcon('ShoppingBag');
export const ShoppingCart = makeIcon('ShoppingCart');
export const SlidersHorizontal = makeIcon('SlidersHorizontal');
export const Store = makeIcon('Store');
export const Sun = makeIcon('Sun');
export const Trash2 = makeIcon('Trash2');
export const Truck = makeIcon('Truck');
export const UserRound = makeIcon('UserRound');
export const Wifi = makeIcon('Wifi');
export const X = makeIcon('X');
export const Repeat = makeIcon('RotateCcw');
export const Gift = makeIcon('ShoppingBag');
export const FileText = makeIcon('ClipboardList');
export const TrendingUp = makeIcon('ArrowUpRight');

export const Mic = makeIcon('Mic');
export const QrCode = makeIcon('QrCode');
export const Share2 = makeIcon('Share2');
export const CheckCircle = CircleCheck;
export const CheckCircle2 = CircleCheck;
